<template>
  <div class="container">
    <div class="manage" v-show="type == 1">
      <div class="top-box">
        <div class="flexrbc">
          <div class="flexr0c">
            <div class="title-label"></div>
            <div class="title">交易预付款充值</div>
          </div>
          <!-- TODO:隐藏手工充值按钮 测试放开 -->
          <div class="addOrg flexrcc" @click="manualCharge" v-show="baseUrl == 'http://192.168.2.226:9023'">
            <div class="btn">手工充值</div>
          </div>
        </div>
      </div>
      <div class="search-box">
        <div class="flexr0c filter">
          <div class="label">时间范围</div>
          <Row>
            <Col span="12">
              <DatePicker :value="value2" format="yyyy/MM/dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 240px" @on-change="handleChange"></DatePicker>
            </Col>
          </Row>
          <div class="label">客户名称</div>
          <Select v-model="select1" style="width: 240px; margin-right: 20px">
            <Option v-for="item in optionList1" :value="item.buyerName + '/' + item.buyerPhone + '/' + item.buyerId" :key="item.buyerName">{{ item.buyerName }}</Option>
          </Select>
          <div class="search-btn" @click="getPage(1)">查询</div>
        </div>
      </div>
      <div class="content-box">
        <div class="content">
          <Table max-height="" :loading="loading" border stripe :columns="tableHead" :data="tableData">
            <template class="flexr0c" slot-scope="{ row, index }" slot="action">
              <div class="flexr0c">
                <div class="edit flexr0c" @click="look(index)">
                  <div class="iconfont">&#xe604;</div>
                  <div class="item">查看</div>
                </div>
              </div>
            </template>
          </Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: right">
              <Page :total="total" :current="1" :pageSize="pageSize" @on-change="changePage" show-elevator show-total></Page>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="item" v-if="type == 2">
      <div class="top flexr0c">
        <img class="addr" src="../../assets/imgs/home/location.png" alt="" />
        <div class="title" @click="manage">交易预付款充值</div>
        <img class="arrow" src="../../assets/imgs/home/rightarrow.png" alt="" />
        <div class="title">{{ msg }}</div>
      </div>
      <div class="content">
        <div class="input-box flexrbc">
          <div class="flexc0s">
            <div class="flexr0c">
              <div class="star" v-show="!isLog">*</div>
              <div class="label">客户名称</div>
            </div>
            <input v-show="isLog" :value="lookInfo.buyerName" disabled type="text" />
            <Select v-show="!isLog" ref="nameDom" v-model="select2" style="width: 368px; margin-right: 20px" @on-change="changeSelect1()">
              <Option v-for="item in optionList2" :value="item.buyerName + '/' + item.buyerPhone + '/' + item.buyerId" :key="item.buyerName">{{ item.buyerName }}</Option>
            </Select>
          </div>
          <div class="flexc0s">
            <div class="flexr0c">
              <div class="label">手机号</div>
            </div>
            <input v-show="!isLog" v-model="phone" disabled type="text" />
            <input v-show="isLog" :value="lookInfo.buyerPhone" disabled type="text" />
          </div>
        </div>
        <div class="input-box flexrbc">
          <div class="flexc0s">
            <div class="flexr0c">
              <div class="star" v-show="!isLog">*</div>
              <div class="label">银行账号</div>
            </div>
            <input v-show="isLog" :value="lookInfo.accountNo" disabled type="text" />
            <Select v-show="!isLog" v-model="select4" style="width: 368px" @on-change="changeSelect2()" @on-click="clickSelect2">
              <Option v-for="item in optionList4" :value="item.accountNo + '/' + item.bankName" :key="item.id">{{ item.accountNo }}</Option>
            </Select>
          </div>
          <div class="flexc0s">
            <div class="flexr0c">
              <div class="label">银行名称</div>
            </div>
            <input v-show="!isLog" v-model="bankName" disabled type="text" />
            <input v-show="isLog" :value="lookInfo.bankName" disabled type="text" />
          </div>
        </div>
        <div class="input-box flexrbc">
          <div class="flexc0s">
            <div class="flexr0c">
              <div class="star" v-show="!isLog">*</div>
              <div class="label">充值金额(元)</div>
            </div>
            <input v-show="isLog" :value="lookInfo.amount" disabled type="text" />
            <input class="input" v-model="chargeNum" v-show="!isLog" type="text" onkeyup="var p2 = parseFloat(value).toFixed(2);value = p2>=0?(/\.0?$/.test(value)?value:p2.replace(/0$/,'').replace(/\.0$/,'')):''" @blur="chargeNumInput($event)" />
          </div>
          <div class="flexc0s">
            <div class="flexr0c">
              <div class="star" v-show="!isLog">*</div>
              <div class="label">充值时间</div>
            </div>
            <input v-show="isLog" :value="lookInfo.fundAddDate" disabled type="text" />
            <DatePicker v-show="!isLog" :options="options1" type="datetime" :editable="false" v-model="dateValue" placeholder="请选择日期时间" style="width: 368px" @on-change="handleChange2"></DatePicker>
          </div>
        </div>
        <div>
          <div class="remark-box">
            <div class="label">备注</div>
            <Input v-show="isLog" :value="lookInfo.remark" maxlength="50" type="textarea" disabled placeholder="" style="width: 860px" />
            <Input v-show="!isLog" v-model="remark" maxlength="50" show-word-limit type="textarea" placeholder="" style="width: 860px" />
          </div>
          <div class="bottom-btn-box flexrcc" v-show="!isLog">
            <div class="cancel" @click="cancel">取消</div>
            <Button class="save" :loading="isLoading" @click="save">保存</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseUrl } from '../../config/http';
export default {
  name: 'charge',
  data() {
    return {
      baseUrl: '', // 请求地址
      msg: '手工充值',
      type: 1,
      isLog: false,
      select1: '全部//',
      select2: '',
      select3: '',
      select4: '',
      chargeNum: '',
      phone: '',
      bankName: '',
      dateValue: '',
      value2: [],
      detail: {},
      userInfo: {},
      lookInfo: {},
      pageSize: 12,
      total: 0,
      loading: true,
      cityList: [],
      options1: {
        disabledDate(date) {
          return date.valueOf() < Date.now() - 2592000000;
        }
      },
      optionList1: [],
      optionList2: [],
      optionList3: [],
      optionList4: [],
      remark: '',
      checkBox1: [],
      tableHead: [
        {
          title: '充值时间',
          key: 'createTime',
          // key: "fundAddDate",
          width: 190,
          resizable: true
        },
        {
          title: '操作类型',
          key: 'actionType',
          width: 110,
          resizable: true
        },
        {
          title: '客户名称',
          key: 'buyerName',
          width: 190,
          resizable: true
        },
        {
          title: '手机号',
          key: 'buyerPhone',
          width: 130,
          resizable: true
        },
        {
          title: '充值金额(元)',
          key: 'amount',
          // width: 100,
          resizable: true
        },
        {
          title: '操作',
          slot: 'action',
          width: 110,
          resizable: true
        }
      ],
      tableData: [],
      isLoading: false,
      userId: ''
    };
  },
  created() {
    this.userId = JSON.parse(localStorage['session']).userId;
    let date2 = this.dateFormat('YYYY-mm-dd', new Date());
    this.dateValue = this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date());
    this.value2.push(date2);
    this.value2.push(date2);
    this.getUserInfo();
    this.getUserName();
    this.getPage(1);
    this.baseUrl = baseUrl;
  },
  methods: {
    //节流
    throttle(fn, wait) {
      var pre = Date.now();
      return function () {
        var context = this;
        var args = arguments;
        var now = Date.now();
        if (now - pre >= wait) {
          fn.apply(context, args);
          pre = Date.now();
        }
      };
    },
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
        }
      }
      return fmt;
    },
    look(index) {
      this.type = 2;
      this.isLog = true;
      this.msg = '查看';
      this.lookInfo = this.tableData[index];
    },
    manualCharge() {
      this.isLog = false;
      this.msg = '手工充值';
      // this.getBankSelect()
      this.getUserName();
      this.type = 2;
    },
    changePage(page) {
      this.getPage(page);
    },
    chargeNumInput(e) {
      if (e.target.value.search('[a-zA-Z]') != -1) {
        this.chargeNum = '';
        this.$Message['error']({
          background: true,
          content: '请正确输入金额'
        });
      } else {
        this.chargeNum = e.target.value;
      }
      if (this.chargeNum) {
        this.chargeNum = parseFloat(this.chargeNum).toFixed(2);
      }
    },
    manage() {
      this.isLog = false;
      this.type = 1;
      this.phone = '';
      this.select2 = '';
      this.select4 = '';
      this.optionList4 = [];
      this.bankName = '';
      this.chargeNum = '';
      this.remark = '';
      this.dateValue = this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date());
      this.getPage(1);
    },
    save() {
      if (this.select2 == '') {
        this.$Message['error']({
          background: true,
          content: '请选择客户名称'
        });
        return;
      }
      if (this.select4 == '') {
        this.$Message['error']({
          background: true,
          content: '请选择银行账号'
        });
        return;
      }
      if (this.chargeNum == '') {
        this.$Message['error']({
          background: true,
          content: '请输入充值金额'
        });
        return;
      }
      if (this.chargeNum.search('[a-zA-Z]') != -1) {
        this.$Message['error']({
          background: true,
          content: '充值金额不能输入字母'
        });
        return;
      }
      if (this.dateValue.length == 0) {
        this.$Message['error']({
          background: true,
          content: '请选择充值时间'
        });
        return;
      }
      this.isLoading = true;
      const session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: '0EfTTyAkb1zfSfCOBCSusWjC6xECLj6G',
        buyerId: this.select2.split('/')[2],
        bankName: this.bankName,
        accountNo: this.select4.split('/')[0],
        accountName: this.select2.split('/')[0],
        amount: this.chargeNum,
        remark: this.remark,
        // createTime: this.dateValue
        fundAddDate: this.dateValue
      };
      this.$http.post(data).then((res) => {
        this.isLoading = false;
        if (res.code == 1) {
          this.manage();
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    cancel() {
      this.manage();
    },
    handleChange(daterange) {
      this.value2 = daterange;
    },
    handleChange2(daterange) {
      this.dateValue = daterange;
    },
    changeSelect1() {
      this.select2 ? (this.phone = this.select2.split('/')[1]) : (this.select2 = '');
      this.select2 ? this.getBankSelect() : (this.select2 = '');
    },
    changeSelect2() {
      if (this.select4) {
        this.bankName = this.select4.split('/')[1];
      } else {
        this.bankName = '';
      }
    },
    clickSelect2() {
      if (this.select2 == '') {
        this.$Message['error']({
          background: true,
          content: '请先选择客户'
        });
      }
    },
    getUserName() {
      var session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: '7e6OAiAvmLIjmLrJ5cpGKzjEhNJJhPWc'
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.optionList1 = JSON.parse(JSON.stringify(res.data));
          this.optionList1.unshift({
            buyerName: '全部',
            buyerPhone: '',
            buyerId: ''
          });
          this.optionList2 = res.data;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getBankSelect() {
      var session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: 'wtj5JW2YdkaWJuXm6kjHQq78mGrnindb',
        buyerId: this.select2.split('/')[2]
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.optionList4 = res.data;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getUserInfo() {
      const session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: '7e6OAiAvmLIjmLrJ5cpGKzjEhNJJhPWc'
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.userInfo = res.data;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getPage(index) {
      this.loading = true;
      const session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: 'djC1X8ZxsJU5rvPRYVIPYdbF6PWDm1sn',
        infundType: 1,
        pageIndex: index,
        pageSize: this.pageSize,
        enterpriseId: session.enterpriseId
      };
      if (this.value2.length != 0) {
        data.startDate = this.value2[0].replace(/\//g, '-');
        data.endDate = this.value2[1].replace(/\//g, '-');
      }
      if (this.select1 != '') {
        data.buyerId = this.select1.split('/')[2];
      }
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.total = res.count;
          res.result_ctn.forEach((item) => {
            item.fundType == 1 && item.infundType == 1 ? (item.actionType = '手工充值') : (item.actionType = '客户转账');
            item.fundType == 2 ? (item.actionType = '过站扣税') : item.actionType;
          });
          this.tableData = res.result_ctn;
          this.loading = false;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
          this.loading = false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 980px;
  text-align: center;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-left: 20px;
  background: #f2f3f5;

  .manage {
    .top-box {
      background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
      border-radius: 10px 10px 0 0;
      width: 100%;
      height: 40px;

      & > div {
        height: 100%;
        width: 928px;
        margin: 0 auto;
      }

      .title-label {
        width: 4px;
        height: 14px;
        background: #2c59c3;
      }

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #2c59c3;
        letter-spacing: 0.4px;
        margin-left: 6px;
      }

      .addOrg {
        background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
        border: 1px solid #4c9b25;
        border-radius: 6px;
        width: 110px;
        height: 30px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #c4ff5b 0%, #4aa824 100%);
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }

        .btn {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
        }
      }
    }

    .search-box {
      /deep/.ivu-select-placeholder {
        text-align: start;
      }

      .filter {
        margin-top: 18px;
        margin-bottom: 14px;

        .label {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #616c84;
          margin: 0 10px 0 26px;
        }

        /deep/.ivu-date-picker-focused input,
        /deep/.ivu-date-picker-focused input {
          font-size: 14px;
        }

        /deep/.ivu-select-selected-value,
        /deep/.ivu-select-item {
          text-align: start;
        }

        /deep/.ivu-input-with-suffix {
          cursor: pointer;
        }

        /deep/.ivu-select-selection {
          height: 38px;
          background: #ffffff;
          // border: 1px solid #DFDFDF;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
          border-radius: 8px;
        }

        /deep/.ivu-select-placeholder,
        /deep/.ivu-select-selected-value {
          height: 38px;
          line-height: 38px;
          padding-left: 24px;
          text-align: start;
        }

        /deep/.ivu-input-suffix {
          line-height: 38px;
        }

        /deep/.ivu-input-with-suffix {
          height: 38px;
          line-height: 38px;
          padding-left: 24px;
          background: #ffffff;
          // border: 1px solid #DFDFDF;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
          border-radius: 8px;
        }

        .search-btn {
          background-image: linear-gradient(180deg, #91caff 0%, #0074d6 97%);
          border: 1px solid #006bc4;
          border-radius: 6px;
          width: 80px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
          cursor: pointer;
          margin-left: 20px;

          &:hover {
            background-image: linear-gradient(180deg, #cce7ff 0%, #027de6 97%);
          }
        }
      }
    }

    .content-box {
      width: 980px;
      min-height: 538px;
      background: #ffffff;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      overflow: hidden;

      .content {
        width: 928px;
        margin-top: 30px;

        .title-box {
          width: 928px;
          height: 40px;
          background-color: rgba(224, 229, 240, 0.3);

          .title {
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #8b93a7;
            flex: 1;
          }
        }

        .item-box {
          width: 928px;
          height: 80px;

          .num {
            font-family: Impact;
            font-size: 24px;
            flex: 1;
            margin: 25px 0;
            color: #2c59c3;
          }
        }

        .edit {
          .item {
            margin-left: 5px;
          }

          &:hover {
            color: #4a90e2 !important;
            cursor: pointer;
          }
        }

        /deep/ .ivu-table th {
          background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
          color: #fff;
        }

        /deep/ .ivu-table th:last-child {
          border-top-right-radius: 10px;
          background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
          color: #fff;
        }

        /deep/ .ivu-table th:first-child {
          // border-top-left-radius: 10px;
          background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
          color: #fff;
        }
      }
    }
  }

  & > .item {
    width: 980px;
    height: 778px;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    position: relative;

    .top {
      .addr {
        width: 14px;
        height: 18px;
        margin: 15px;
        margin-right: 8px;
      }

      .title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #adb2bc;
        letter-spacing: 0.26px;
        cursor: pointer;
      }

      .arrow {
        width: 7px;
        height: 14px;
        margin: 0 10px;
      }
    }

    .content {
      width: 860px;

      .input-box {
        .star {
          font-size: 10px;
          color: red;
        }

        .label {
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          color: #003d00;
          letter-spacing: 0.26px;
          line-height: 20px;
          margin: 8px 10px;
        }

        input {
          width: 368px;
          height: 48px;
          background: #f5f7fa;
          border-radius: 8px;
          padding-left: 24px;
        }

        .input {
          background: #ffffff;
          // border: 1px solid #DFDFDF;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
          border-radius: 8px;
        }

        /deep/.ivu-select-selection {
          height: 48px;
          background: #ffffff;
          // border: 1px solid #DFDFDF;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
          border-radius: 8px;
        }

        /deep/.ivu-select-placeholder,
        /deep/.ivu-select-selected-value {
          height: 48px;
          line-height: 48px;
          padding-left: 24px;
          text-align: start;
        }

        /deep/.ivu-input-suffix {
          line-height: 48px;
        }

        /deep/.ivu-input-with-suffix {
          height: 48px;
          line-height: 48px;
          padding-left: 24px;
          background: #ffffff;
          // border: 1px solid #DFDFDF;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
          border-radius: 8px;
          cursor: pointer;
        }
      }

      .remark-box {
        .label {
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          color: #9097a9;
          letter-spacing: 0.26px;
          margin: 20px 0 8px 0;
          text-align: start;
        }

        /deep/ textarea.ivu-input {
          height: 120px;
          background: #ffffff;
          // border: 1px solid #DFDFDF;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
          border-radius: 8px;
          resize: none;
        }

        /deep/ .ivu-input[disabled] {
          background: #f5f7fa;
          color: #000;
          font-size: 12px;
        }
      }

      .bottom-btn-box {
        & > div,
        button {
          width: 160px;
          height: 40px;
          line-height: 40px;
          border-radius: 4px;
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #ffffff;
          letter-spacing: 0.34px;
          text-align: center;
          margin-top: 50px;
          cursor: pointer;
        }

        .cancel {
          background-image: linear-gradient(180deg, #f5515f 0%, #9f041b 100%);
          border: 1px solid #af1228;

          &:hover {
            background-image: linear-gradient(180deg, #ff7d89 0%, #b4051f 100%);
          }
        }

        .save {
          margin-left: 40px;
          background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
          border: 1px solid #285ed3;

          &:hover {
            background-image: linear-gradient(180deg, #5295f5 0%, #2559d1 99%);
          }
        }
      }

      .filter {
        margin-bottom: 14px;

        .label {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #616c84;
          margin: 0 10px 0 26px;

          &:first-child {
            margin-left: 0;
          }
        }

        /deep/.ivu-date-picker-focused input,
        /deep/.ivu-date-picker-focused input {
          font-size: 14px;
        }

        /deep/.ivu-select-selected-value,
        /deep/.ivu-select-item {
          text-align: start;
        }
      }
    }
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
  }

  /deep/.ivu-select-selected-value,
  /deep/.ivu-select-item {
    text-align: start;
    border-bottom: 1px solid #fafafa;
  }

  /deep/span.ivu-select-selected-value {
    border-bottom: none;
  }

  /deep/.ivu-select-item:last-child {
    border-bottom: none;
  }

  /deep/.ivu-radio-checked {
    color: #2c59c3;
  }

  /deep/.ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
  .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
    background-color: rgba(236, 241, 247, 0.4);
  }

  /deep/.ivu-table-stripe .ivu-table-body tr.ivu-table-row-hover td,
  .ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-hover td {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-table-row-hover {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-input-with-suffix {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.07);
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
    border: 1px solid #dcdee2;
    border-right: none;
  }

  /deep/.ivu-table td,
  .ivu-table th {
    border-bottom: none;
  }

  /deep/.ivu-table:before {
    display: none;
  }

  input:disabled {
    border: 1px solid rgba(118, 118, 118, 0.3);
    box-shadow: none;
  }

  /deep/.ivu-input-wrapper {
    width: 100%;
  }
}
</style>
